module.exports = __webpack_public_path__ + "static/media/bamboo.2120cc5d.png";